import latestSchema from './v5';

export default latestSchema;
